import { flow } from "fp";
import { QueryKey } from "react-query";

import { Branches } from "~/Branch";
import { ID, Reference } from "~/Data";
import * as Job from "~/Job";
import * as Log from "~/Log";
import { Request } from "~/Request";
import { Time } from "~/Time";

export const toEndpoint = ({ company, driver, dateTime }: Query.QueryParams) =>
  `/companies/${company.id}/drivers/${
    driver.id
  }/logs/${Time.DateTime.toISOWithoutTime({ dateTime })}`;

export namespace Query {
  export const tag = () => "Driver Logs" as const;

  export type QueryIdParams = Time.DateTime & {
    readonly driver: Reference.Reference;
  };

  export type QueryParams = QueryIdParams & {
    readonly company: Reference.Reference;
  };

  export const id = ({ driver, dateTime }: QueryIdParams): ID.ID =>
    `${driver.id}-${Time.DateTime.toISOWithoutTime({ dateTime })}`;

  export const key = ({ driver, dateTime }: QueryIdParams): QueryKey => [
    tag(),
    id({ driver, dateTime }),
  ];

  export const request = ({
    company,
    dateTime,
    driver,
  }: QueryParams): Request.Fn<Log.Log> => {
    const endpoint = toEndpoint({ company, driver, dateTime });
    return flow(
      Request.fromConfig({ endpoint }),
      Request.Expect.status(200),
      Request.Expect.json(Log.Response.runtime()),
      Request.onSuccess(Log.Response.Query.decode({ driver, dateTime }))
    );
  };

  export const prefetch = () => {
    Branches.use();
    Job.use();
  };
}
